/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import styled from 'styled-components'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Theme } from '@nexigendigital/nxui'
import { aud, titleCase } from 'helpers/utils'
import { ProductServiceType, Weight } from 'models/enums'
import { CartItem } from 'models/shop'
import { useAppSelector } from 'store/hooks'

import Configs from 'containers/shop/cart/configs'
import Addons from 'containers/shop/cart/addons'

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function OrderItems() {
    const { cart, items } = useAppSelector((state) => state.shop)

    function productType(item: CartItem): string {
        const pendingItem = items.find((pendingItem) => pendingItem.product_id === item.product_id && pendingItem.name === item.name)

        return pendingItem ? pendingItem.product_type : ''
    }

    if (!cart) {
        return null
    }

    return (
        <StyledCartItems>
            {cart.items.map((item) => {
                return (
                    <Item key={`${item.name}-${item.product_id}`}>
                        <Product>
                            <Description>
                                <Name>
                                    {item.name}
                                </Name>
                                <Type>
                                    {titleCase(productType(item))}{' '}{titleCase(item.order_type)}
                                </Type>
                            </Description>
                            <Actions>
                                <Pricing>
                                    {aud(item.price.total)}
                                </Pricing>
                            </Actions>
                        </Product>
                        <Configs item={item}/>
                        {(productType(item) === ProductServiceType.SharedHosting && item.addons) &&
                            <Addons addons={item.addons}/>
                        }
                    </Item>
                )
            })}
        </StyledCartItems>
    )
}

/**********************************************************************************************************
 *   CUSTOM STYLING
 **********************************************************************************************************/
const StyledCartItems = styled.div`
    display: grid;
    font-size: 0.875rem;
    width: 100%;
`

const Item = styled.div`
    display: grid;
    border-bottom: 1px solid ${props => props.theme['gray--100']};
`

const Product = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 12px;
`

const Description = styled.div`
    display: flex;
    gap: 4px;
`

const Type = styled.div`
    white-space: nowrap;
    ${Theme.Functions.setFont('Inter', Weight.Medium)};
    color: ${props => props.theme['icon--300']};
`

const Name = styled.div`
    ${Theme.Functions.setFont('Inter', Weight.Medium)};
    color: ${props => props.theme['text--300']};
`

const Actions = styled.div`
    display: flex;
`

const Pricing = styled.div`
    ${Theme.Functions.setFont('Inter', Weight.Medium)};
    color: ${props => props.theme['text--300']};
`
